import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './PlanGate.css';

interface PlanGateProps {
    requiredPlan: 'pro';
    userPlan: 'basic' | 'pro';
    children: React.ReactNode;
    /** If true, renders children as blurred/locked instead of hiding */
    showLocked?: boolean;
}

const PlanGate: React.FC<PlanGateProps> = ({ requiredPlan, userPlan, children, showLocked = false }) => {
    const { language } = useLanguage();
    const T = (en: string, vi: string) => language === 'vi' ? vi : en;

    const hasAccess = userPlan === requiredPlan || (requiredPlan === 'pro' && userPlan === 'pro');

    if (hasAccess) return <>{children}</>;

    if (showLocked) {
        return (
            <div className="plan-gate-wrapper">
                <div className="plan-gate-locked" aria-hidden="true">
                    {children}
                </div>
                <div className="plan-gate-overlay">
                    <div className="plan-gate-badge">🔒 Pro</div>
                    <p className="plan-gate-msg">
                        {T('This feature is only available in the ', 'Tính năng này chỉ có trong ')}
                        <strong>{T('Pro plan', 'gói Pro')}</strong>.
                    </p>
                    <p className="plan-gate-sub">
                        {T('Contact Admin to upgrade your account.', 'Liên hệ Admin để nâng cấp tài khoản.')}
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="plan-gate-banner">
            <span className="plan-gate-icon">🔒</span>
            <div>
                <strong>{T('Pro Feature', 'Tính năng Pro')}</strong>
                <p>
                    {T(
                        'This feature is only available in the Pro plan. Contact Admin to upgrade.',
                        'Tính năng này chỉ có trong gói Pro. Liên hệ Admin để nâng cấp.'
                    )}
                </p>
            </div>
        </div>
    );
};

export default PlanGate;
